import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import BackgroundImage from "gatsby-background-image"

const HomeBackground = ({ children }) => {
  const { desktop } = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "background.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 4160) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )
  return (
    <div>
      <BackgroundImage
        Tag="section"
        backgroundColor={`#040e18`}
        fluid={{
          ...desktop.childImageSharp.fluid,
          media: `(min-width: 1401px)`,
        }}
        title="Art-Directed Fullscreen Background"
        id="adfullscreenbg"
        role="img"
        aria-label="Art-Directed Fullscreen Background"
        preserveStackingContext={true}
        style={{
          height: "50vh",
        }}
      >
        {children}
      </BackgroundImage>
    </div>
  )
}

const StyledFullBackground = styled(HomeBackground)`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default StyledFullBackground
